import { Badge } from '@simplywallst/ui-core/next';

import { CompanyIcon } from '@/components/CompanyIcon';
import { CountryFlag } from '@/components/CountryFlag';

import type { ISO2 } from '@/constants/countries';

export type Props = {
  type: 'primary';
  id: string;
  label: string;
  name: string;
  website: string | null;
  uniqueSymbol: string;
  tickerSymbol: string;
  exchangeCountryIso: ISO2 | null;
  tag: string | null;
};

export const PrimaryListing = ({
  label,
  exchangeCountryIso,
  tickerSymbol,
  uniqueSymbol,
  tag,
  website,
}: Props) => {
  return (
    <div>
      <div
        className="relative flex h-16 cursor-pointer select-none items-center pb-0"
        data-cy-id={`primary-listing-${label}`}
      >
        <div className="pl-4">
          <CompanyIcon
            website={website}
            tickerSymbol={tickerSymbol ?? uniqueSymbol?.split?.(':')?.[1]}
            size={40}
          />
        </div>
        <div className="flex w-full flex-nowrap justify-between">
          <div className="max-w-[250px] pl-3 pt-0 sm:max-w-[350px]">
            <div className="flex flex-row flex-wrap justify-start">
              <h4 className="m-0 truncate font-normal text-solid md:font-medium">
                {label}
              </h4>
            </div>
            <div className="grid grid-cols-[24px_auto] items-center">
              <CountryFlag countryISO={exchangeCountryIso} />
              <p className="m-0 text-tiny text-soft">{uniqueSymbol}</p>
            </div>
          </div>
          <div className="w-15 flex flex-wrap justify-center pt-2 sm:w-20">
            {tag && <Badge>{tag}</Badge>}
          </div>
        </div>
      </div>
    </div>
  );
};
